const styles = theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
    [theme.breakpoints.down('xs')]: {
      // padding: '70px 16px 16px 16px',
      padding: '0px 16px 16px 16px',
    },
  },

  titleContainer: {
    padding: '32px 0',
    borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
  },

  title: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '600',
    fontSize: '28px',
    lineHeight: '150%',
  },

  switchContainer: {
    // marginTop: '40px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '24px',
      overflow: 'auto',
    },
  },

  openModalBtnContainer: {
    marginTop: '21px',
  },

  content: {
    width: '100%',
    display: 'flex',
    gap: '24px',

    marginTop: '30px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginTop: '20px',
    },
    [theme.breakpoints.down(768)]: {
      gap: '0px',
    },
  },

  sideBarContent: {
    width: '25%',
    minWidth: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: '100%',
    },
  },
  searchFieldContainer: {
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '12px',
    },
  },
  sideBar: {},

  dataContainer: {
    flex: '1',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flex: '0 1 auto',
    },
  },

  topBar: {
    padding: '4px 0 24px 0',
    // borderBottom: `1px solid ${theme.palette.primary.borderColor}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '16px',
  },
  totalResults: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '21px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap',
  },
  appliedFiltersContainer: {},

  // dataList: {
  //   marginTop: '24px',
  // },
});

export default styles;
